<!--
 * @Author: 陈红伟 chenhw2019@gmail.com
 * @Date: 2023-10-11 14:46:57
 * @LastEditors: 陈红伟 chenhw2019@gmail.com
 * @LastEditTime: 2024-01-30 11:23:56
 * @FilePath: /seller.sviptrader.com/src/views/configure/rulesManage/list/components/talentClue/components/distribute.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="distribute-wrapper" v-loading="loading">
		<el-button type="primary" v-if="isSearch" @click="handleEdit" v-auth="['configure:rules:talentClue:filter:edit']">编辑规则</el-button>
		<div class="rule-show mt-16" v-if="isSearch">
			<InfoCard title="线索过滤规则">
				<div slot="content" class="yx-color-text-primary">
					<div v-for="conf in filterMapList" :key="conf.valueKey">
						{{ getFilterRuleDesc(conf, form) }}
					</div>
				</div>
			</InfoCard>
		</div>
		<div class="edit-wrapper mt-24 flex-row flex-just-start" v-if="isEdit">
			<div class="label font-h4-medium yx-color-text-primary">
				线索过滤规则
				<span class="color-gy-7 font-h6-regular ml-4 cursor-pointer" @click="dialogVisible = true">《规则说明》</span>
			</div>
			<div class="edit-content ml-16 font-h4-regular">
				<div>
					<el-checkbox-group v-model="form.filterNoContact">
						<el-checkbox :label="2">
							无公开联系方式
							<el-popover placement="top-start" trigger="hover">
								<div class="font-h4-medium mb-8">简介联系方式</div>
								<img style="height: 240px" src="https://cdn.chaoyongbushou.com/wx/20231012/1697091622284-image.png" alt="" />
								<el-button type="text" slot="reference">预览</el-button>
							</el-popover>
						</el-checkbox>
					</el-checkbox-group>
				</div>
				<div class="mt-12">
					<el-checkbox v-model="form.filterExistsTeamSea" :true-label="1" :false-label="0">达人已存在团队公海</el-checkbox>
				</div>
				<div class="mt-12">
					<el-checkbox disabled :true-label="1" :false-label="0" v-model="form.filterHaveFollow">达人已有跟进人</el-checkbox>
				</div>
				<!-- <div class="mt-12">
					<el-checkbox :true-label="1" :false-label="0" v-model="form.filterDisableAnchor">达人已被标记为"失效状态"</el-checkbox>
				</div> -->
			</div>
			<div class="operate-bottom">
				<el-button @click="cancel">取消</el-button>
				<el-button type="primary" @click="submit">保存</el-button>
			</div>
		</div>
		<el-dialog class="cooperationProgress_monitoring_dialog" :visible.sync="dialogVisible" width="400px" :close-on-click-modal="false">
			<div slot="title">
				<span class="fz-14 yx-pingfang-Medium yx-color-g-9">规则说明</span>
			</div>
			<div class="font-h4-medium">
				插件首先根据"线索筛选条件"筛选所得达人再根据"线索过滤规则"来过滤不符合条件的达人，多过滤条件被同时选中为"或"关系，各筛选条件过滤规则如下：
			</div>
			<div class="font-h4-regular cooperationProgress_monitoring_bullets font-h4-regular">无公开联系方式：达人未在官方达人广场留联系方式信息；</div>
			<div class="font-h4-regular cooperationProgress_monitoring_bullets font-h4-regular">
				达人已存在团队公海：达人已被收录至团队公海包括有人跟进、无人跟进情况；
			</div>
			<div class="font-h4-regular cooperationProgress_monitoring_bullets font-h4-regular">达人已有跟进人：达人已被收录至团队公海且有人跟进；</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="dialogVisible = false">我知道了</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { setFilterRule, getFilterRule } from '@/api/settings.js';
import InfoCard from './infoCard.vue';
import { getFilterRuleDesc, filterMapList } from '../const';
export default {
	data() {
		return {
			dialogVisible: false,
			mode: 'search',
			ruleDialogVisible: false,
			distributeType: '',
			selectArr: [],
			form: {
				filterNoContact: [],
				filterExistsTeamSea: 0,
				filterHaveFollow: 1,
				filterDisableAnchor: 0,
			},
			loading: false,
			filterMapList: Object.freeze(filterMapList),
		};
	},
	components: {
		InfoCard,
	},
	computed: {
		isEdit() {
			return this.mode === 'edit';
		},
		isSearch() {
			return this.mode === 'search';
		},
	},
	created() {
		this.getFilterRule();
	},
	methods: {
		getFilterRuleDesc,
		async getFilterRule() {
			try {
				this.loading = true;
				const { data } = await getFilterRule({
					platformId: dataMap.PLATFORM_DY.value,
				});
				this.form = data;
			} finally {
				this.loading = false;
			}
		},
		handleEdit() {
			this.mode = 'edit';
		},
		cancel() {
			this.mode = 'search';
		},
		async submit() {
			try {
				await setFilterRule({
					...this.form,
					platformId: dataMap.PLATFORM_DY.value,
				});
				this.$message.success('保存成功');
				this.getFilterRule();
				this.mode = 'search';
			} catch (error) {
				console.log(error);
			}
		},
	},
};
</script>

<style lang="less" scoped>
/deep/ .el-checkbox__label {
	padding-left: 8px;
}
.operate-bottom {
	position: fixed;
	bottom: 0;
	left: 148px;
	height: 64px;
	right: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.08), 0px -2px 6px 0px rgba(0, 0, 0, 0.06), 0px -4px 8px 2px rgba(0, 0, 0, 0.04);
}
</style>
